import React, { useContext } from 'react';

import styled from '@emotion/styled';

import TranslatingContainerProvider, { TranslatingContainerContext } from './TranslatingContainerProvider';

interface TranslatingContainerProp {
  width?: number | string;
  children: React.ReactNode;
}

const TranslatingContainerCore = styled.div<{
  sliderIndex: number;
  width?: number | string;
}>`
  display: grid;
  grid-auto-flow: column;
  width: ${({ width = 400 }) =>
    typeof width === 'string' ? width : 'fit-content'};

  transform: ${({ sliderIndex = 0, width = 400 }) =>
    typeof width === 'string'
      ? `translateX(-${sliderIndex * 100}%)`
      : `translateX(-${width * sliderIndex}px)`};
  transition: transform 0.3s ease-in-out;

  & > * {
    height: fit-content;
    width: ${({ width = 400 }) =>
      typeof width === 'string' ? width : `${width}px`} !important;
  }

  @media (max-width: 884px) {
    grid-auto-columns: 100%;
    width: 100%;
    transform: ${({ sliderIndex = 0 }) => `translateX(-${100 * sliderIndex}%)`};

    & > * {
      width: 100% !important;
    }
  }
`;

const TranslatingContainerInner = ({
  width,
  children,
}: TranslatingContainerProp) => {
  const { sliderIndex } = useContext(TranslatingContainerContext)!;
  return (
    <TranslatingContainerCore sliderIndex={sliderIndex} width={width}>
      {children}
    </TranslatingContainerCore>
  );
};

const TranslatingContainer = ({
  width,
  children,
}: TranslatingContainerProp) => {
  const existingCtx = useContext(TranslatingContainerContext);

  if (existingCtx) {
    return (
      <TranslatingContainerCore
        sliderIndex={existingCtx.sliderIndex}
        width={width}
      >
        {children}
      </TranslatingContainerCore>
    );
  }

  return (
    <TranslatingContainerProvider>
      <TranslatingContainerInner width={width}>
        {children}
      </TranslatingContainerInner>
    </TranslatingContainerProvider>
  );
};

export default TranslatingContainer;
